import { useMemo } from 'react';

export function useBalance(isDemo, demoBalance, userBalance) {
  return useMemo(() => {
    return isDemo ? demoBalance : userBalance;
  }, [demoBalance, userBalance, isDemo]);
}
